<template>
  <div class="rtd-wrapper">
    <div class="rtd-header">
      <p>{{ title }}</p>
    </div>
    <div class="rtd-content">
      <div class="rtd-cell">
        <p class="rtd-title">采集时间:</p>
        <p class="rtd-text">{{ dt }}</p>
      </div>
      <div class="rtd-cell">
        <p class="rtd-title">温度:</p>
        <p class="rtd-text">{{ wd }}</p>
      </div>
      <div class="rtd-cell">
        <p class="rtd-title">测量值:</p>
        <p class="rtd-text">{{ clz }}</p>
      </div>
      <div class="rtd-cell">
        <p class="rtd-title">变化值:</p>
        <p class="rtd-text">{{ pcz }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RealtimeData',
  props: {
    title: {
      type: String,
      default: ''
    },
    dt: {
      type: String,
      default: ''
    },
    clz: {
      type: String,
      default: ''
    },
    pcz: {
      type: String,
      default: ''
    },
    wd: {
      type: String,
      default: ''
    },
  },
  data () {
    return {

    }
  }
}
</script>

<style lang='less' scoped>
.rtd-wrapper {
  border-radius: 4px;
  border: 1px solid #999999;
  margin-right: 12px;
  .rtd-header {
    position: relative;
    background-color: #1f2360;
    color: #ffffff;
    font-weight: bold;
    padding: 9px 0 9px 40px;
    p {
      padding: 0;
      margin: 0;
    }
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 14px;
      width: 14px;
      border-radius: 2px;
      left: 16px;
      background-color: #3377fe;
    }
  }
  .rtd-content {
    display: flex;
    flex-wrap: wrap;
    background-color: #2b316b;
    .rtd-cell {
      width: 50%;
      font-size: 14px;
      font-weight: bold;
      padding: 6px 12px;
      .rtd-title {
        //olor: #9195b8;
        color: #ffffff;
        margin-bottom: 6px;
      }
      .rtd-text {
        //color: #2e5bc5;
        color: #ffffff;
        margin-bottom: 6px;
      }
      &:nth-child(2n + 1) {
        width: 60%;
        border-right: 1px dashed #9195b8;
      }
      &:nth-child(2n) {
        width: 40%;
      }
      &:first-child {
        border-bottom: 1px dashed #9195b8;
      }
      &:nth-child(2) {
        border-bottom: 1px dashed #9195b8;
      }
    }
  }
}
</style>
